import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_MEMBERSHIP_PPMU_ENABLED_FOR = createFcmDetails('membership_ppmu_enabled_for', {
	owner: 'United PD, Site Platform',
	context: 'Post Promote Membership Upsell (PPMU)',
	description: 'This configuration determines whether PPMU is enabled for a country',
	import: false,
});
